import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import UploadImages from '@/plugins/graphql/mutations/v2/ecommerce/product-image-upload.gql';
import RemoveImages from '@/plugins/graphql/mutations/v2/ecommerce/product-images-remove.gql';
import ImageUploadMixin from '../ImageUploadMixin';
let ProductImageUploadMixin = class ProductImageUploadMixin extends mixins(ImageUploadMixin) {
    async uploadImages(productUuid, images) {
        const inputImages = images.map((input) => input.file);
        await this.$apollo.mutate({
            mutation: UploadImages,
            variables: {
                input: {
                    productUuid,
                    images: inputImages,
                },
            },
        });
    }
    async removeImages(productUuid, imageUuids) {
        await this.$apollo.mutate({
            mutation: RemoveImages,
            variables: {
                input: {
                    productUuid,
                    photos: imageUuids,
                },
            },
        });
    }
};
ProductImageUploadMixin = __decorate([
    Component
], ProductImageUploadMixin);
export default ProductImageUploadMixin;
